import { trackEvent } from '../../lib/analytics';
import Squiggle from './Squiggle';

const Hero = () => {
  const handleCtaClick = () => {
    trackEvent('cta_clicked', {
      cta_label: 'reserver-hero',
      page: 'jpo-portes-ouvertes',
    });
  };

  return (
    <section className="hero" id="top">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-blob hero-blob-1" />
        <div className="hero-blob hero-blob-2" />
        <div className="hero-grid" />
      </div>

      <div className="container hero-inner">
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          Journée Portes Ouvertes · Édition 2026
        </div>

        <h1 className="hero-title">
          <span className="hero-title-line">Le tuteur IA</span>
          <span className="hero-title-line hero-title-emph">
            <span className="hero-title-emph-word">qui révise</span>
            <Squiggle className="hero-squiggle" />
          </span>
          <span className="hero-title-line">avec votre enfant à la maison.</span>
        </h1>

        <p className="hero-lede">
          GSS est pionnier d'un tuteur IA interactif qui accompagne nos élèves chaque soir.
          Découvrez Lumi en démo samedi 16 mai, 9h–13h.
          Test de positionnement offert en primaire, rencontre avec les enseignants en maternelle.
        </p>

        <div className="hero-meta">
          <div className="hero-meta-card">
            <span className="hero-meta-eyebrow">Date</span>
            <span className="hero-meta-value">Samedi 16 mai</span>
          </div>
          <div className="hero-meta-card">
            <span className="hero-meta-eyebrow">Horaires</span>
            <span className="hero-meta-value">9h&nbsp;– 13h</span>
          </div>
          <div className="hero-meta-card">
            <span className="hero-meta-eyebrow">Niveaux</span>
            <span className="hero-meta-value">Maternelle &amp; Primaire</span>
          </div>
        </div>

        <div className="hero-cta-row">
          <a
            href="#rsvp"
            onClick={handleCtaClick}
            className="btn btn-primary btn-lg"
          >
            Réserver une place
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
          <p className="hero-cta-note">Gratuit · Sans engagement · 30 secondes</p>
        </div>
      </div>

      <svg
        className="curved-divider"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0 40 Q360 80 720 40 T1440 40 L1440 80 L0 80 Z"
          fill="var(--gss-teal)"
        />
      </svg>
    </section>
  );
};

export default Hero;
